function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border: 1px solid #46494c;\n  border-left: 4px solid transparent !important;\n  border-right: 4px solid transparent !important;\n  border-top: 5px solid #797e83 !important;\n  border-bottom: none !important;\n  transform: none;\n  content: ' ';\n  display: block;\n  pointer-events: none;\n  position: absolute;\n  z-index: 4;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  cursor: pointer;\n  top: 46%;\n  right: 26px;\n  &:after {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  .mui-dt-root {\n    ",
        ";\n    ",
        ";\n  }\n\n  .mui-dt-input-root {\n    cursor: pointer;\n    background-color: var(--dcm-checkout-input-bg, #fcfdfe) !important;\n    border: 1px solid var(--dcm-checkout-input-border-color, #caced4);\n    border-radius: 4px;\n    &.mui-dt-input-error {\n      border: 1px solid #e25241;\n    }\n  }\n\n  .mui-dt-input-input {\n    font-size: 16px;\n    padding: 22px 5px 6px 20px;\n    caret-color: #6fa48e;\n    color: var(--dcm-checkout-text-color, #5d666d);\n    height: 23px;\n    width: calc(100% - 18px - 34px);\n\n    @media only screen and (min-width: 768px) {\n      font-size: 13px;\n      height: 19px;\n      padding: 19px 34px 5px 18px;\n    }\n\n    &:focus {\n      background-color: transparent;\n    }\n  }\n\n  .mui-dt-label-root {\n    color: var(--dcm-checkout-text-muted-color, #858788);\n    font-size: 16px;\n    transform: translate(20px, 19px) scale(1);\n    transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,\n      font-size 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    &.mui-dt-label-shrink {\n      // transform: translate(20px, 10px) scale(0.8);\n      transform: translate(20px, 10px);\n      font-size: 10px;\n\n      @media only screen and (min-width: 768px) {\n        // transform: translate(18px, 8px) scale(0.8);\n        transform: translate(18px, 8px);\n        font-size: 10px;\n      }\n    }\n    &.mui-dt-label-error {\n      color: #e25241 !important;\n    }\n    &.mui-dt-label-focused {\n      color: var(--dcm-checkout-text-muted-color, #858788);\n    }\n\n    @media only screen and (min-width: 768px) {\n      font-size: 13px;\n      transform: translate(18px, 17px) scale(1);\n    }\n  }\n  .mui-dt-input-underline:before {\n    display: none;\n  }\n  .mui-dt-input-underline:after {\n    transform: scale(0) !important; // remove underline highlight\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { space, width } from 'styled-system';
import FilledInput from '@material-ui/core/FilledInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
export var ArrowCss = css(_templateObject());
var Arrow = styled.div(_templateObject1(), ArrowCss);
export var ArrowImage = function() {
    return /*#__PURE__*/ _jsx(Arrow, {});
};
export var DefaultSelect = function(_param) {
    var id = _param.id, name = _param.name, label = _param.label, onChange = _param.onChange, value = _param.value, error = _param.error, errorMessage = _param.errorMessage, onValueAfterError = _param.onValueAfterError, _param_disableEmptyOption = _param.disableEmptyOption, disableEmptyOption = _param_disableEmptyOption === void 0 ? false : _param_disableEmptyOption, _param_customIcon = _param.customIcon, customIcon = _param_customIcon === void 0 ? null : _param_customIcon, children = _param.children, props = _object_without_properties(_param, [
        "id",
        "name",
        "label",
        "onChange",
        "value",
        "error",
        "errorMessage",
        "onValueAfterError",
        "disableEmptyOption",
        "customIcon",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(StyledSelectWithLabel, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsxs(FormControl, {
            variant: "filled",
            classes: {
                root: 'mui-dt-root'
            },
            children: [
                /*#__PURE__*/ _jsx(InputLabel, {
                    htmlFor: id,
                    classes: {
                        root: 'mui-dt-label-root',
                        focused: 'mui-dt-label-focused',
                        error: 'mui-dt-label-error',
                        shrink: 'mui-dt-label-shrink'
                    },
                    className: error ? 'mui-dt-label-error' : '',
                    children: error && errorMessage ? errorMessage : label
                }),
                /*#__PURE__*/ _jsxs(Select, _object_spread_props(_object_spread({
                    native: true,
                    id: id,
                    error: !!error,
                    value: value,
                    onChange: function(e) {
                        onChange(e);
                        if (error) {
                            onValueAfterError(e);
                        }
                    },
                    input: /*#__PURE__*/ _jsx(FilledInput, {
                        name: name,
                        id: id,
                        classes: {
                            root: 'mui-dt-input-root',
                            input: 'mui-dt-input-input',
                            error: 'mui-dt-input-error',
                            underline: 'mui-dt-input-underline',
                            inputAdornedEnd: 'mui-dt-input-icon'
                        }
                    }),
                    IconComponent: customIcon || ArrowImage
                }, props), {
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            disabled: disableEmptyOption,
                            "aria-label": "empty"
                        }),
                        children
                    ]
                }))
            ]
        })
    }));
};
var StyledSelectWithLabel = styled.div(_templateObject2(), space, width);
